import { curry } from 'lib/util'

/**
 * Copy QR Code Event Handler
 *
 * Copies the object making up the QR code to the clipboard.
 *
 * @param module    the application module specification
 * @param component the component specification
 * @param event     the platform event
 */
const copyQRCode = (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  event: Gaia.PlatformEvent,
) => {
  const { [G.CLIPBOARD]: clipboardAdapter, [G.EVENTS]: eventBus } = module[G.ADAPTER]
  const { licence: model = {} } = module[G.MODEL][G.CHILDREN] || {}
  const valueCache = model[G.CACHE]?.value || {}

  clipboardAdapter.setText({
    detail: JSON.stringify({
      serial: valueCache.serial,
      duration_months: valueCache.duration,
      license_counter: valueCache.counter,
      signature: valueCache.licenseKey,
    }),
  })

  eventBus.dispatch(eventBus.type(G.DATA, G.UPDATE),
    {
      message: 'Code copied to clipboard',
      severity: 'success',
      action: false,
      close: 3000,
    })
}

export default curry(copyQRCode)
